export const REFILL_MAX = 1000000;
export const LOT_NUMBER_MAX = 30;
